import React from 'react'
import PropTypes from 'prop-types'
import ModuleContainer from '../../components/module-container'
import PaymentIcons from '../../../components/footer/payment-icons'

const PaymentMethods = React.forwardRef(
    ({moduleId, moduleType, pageId, anchor, background, spacing}, ref) => {
        return (
            <ModuleContainer
                moduleId={moduleId}
                moduleType={moduleType}
                pageId={pageId}
                anchor={anchor}
                background={background}
                spacing={spacing}
                ref={ref}
                display="flex"
                justifyContent="center"
            >
                <PaymentIcons variant="center" maxWidth="40rem" />
            </ModuleContainer>
        )
    }
)

if (process.env.NODE_ENV !== 'production') {
    PaymentMethods.displayName = 'PaymentMethods'
}

PaymentMethods.propTypes = {
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string,
    anchor: PropTypes.string,
    background: PropTypes.oneOf(['default', 'subtle', 'strong', 'inverse']),
    spacing: PropTypes.oneOf(['default', 'reduced', 'min', 'min-top', 'min-bottom'])
}

export default PaymentMethods
